var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighFidelityDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6433 5.88995C62.2729 3.51952 58.3795 3.6937 56.2303 6.26634L46.5225 17.8861L52.6473 24.0109L64.2672 14.3031C66.8394 12.1537 67.0136 8.26025 64.6433 5.88995Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9746 25.7617V56.7001C68.9746 61.7131 64.9111 65.7781 59.898 65.7781H51.5039C56.517 65.7781 60.5805 61.7131 60.5805 56.7001V25.7617H68.9746Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.142 20.9505C13.6503 20.9505 14.8731 19.7277 14.8731 18.2194C14.8731 16.711 13.6503 15.4883 12.142 15.4883C10.6336 15.4883 9.41089 16.711 9.41089 18.2194C9.41089 19.7277 10.6336 20.9505 12.142 20.9505Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.788 20.9505C23.2963 20.9505 24.5191 19.7277 24.5191 18.2194C24.5191 16.711 23.2963 15.4883 21.788 15.4883C20.2796 15.4883 19.0569 16.711 19.0569 18.2194C19.0569 19.7277 20.2796 20.9505 21.788 20.9505Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4337 20.9505C32.9421 20.9505 34.1648 19.7277 34.1648 18.2194C34.1648 16.711 32.9421 15.4883 31.4337 15.4883C29.9254 15.4883 28.7026 16.711 28.7026 18.2194C28.7026 19.7277 29.9254 20.9505 31.4337 20.9505Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5222 17.8866L52.5003 10.7313C52.173 10.6956 51.8409 10.6758 51.504 10.6758H10.1034C5.09031 10.6758 1.02539 14.7393 1.02539 19.7538V25.7617H35.3292C37.5246 23.0937 38.0961 19.6039 46.5222 17.8866Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.647 24.0131C52.5256 24.6212 52.3708 25.2044 52.1875 25.7634H60.5805V19.7554C60.5805 19.013 60.4893 18.2921 60.3213 17.6016L52.647 24.0131Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6001 12.6914C65.2693 13.2882 64.8247 13.8366 64.2667 14.3026L60.3213 17.5989C60.4893 18.2896 60.5805 19.0104 60.5805 19.7528V25.7608H68.9745V19.7528C68.9745 16.8996 67.6578 14.3555 65.6001 12.6914Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1875 25.7617C49.7868 33.0819 42.3078 36.1039 35.6493 32.4128C33.4329 31.1841 33.0032 28.1643 34.7873 26.3644C34.9806 26.1693 35.1597 25.9679 35.3292 25.7617H1.02539V56.7001C1.02539 61.7131 5.09031 65.7781 10.1034 65.7781H51.504C56.5171 65.7781 60.5806 61.7131 60.5806 56.7001V25.7617H52.1875Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5221 17.8867C37.445 19.7368 37.4837 23.6438 34.7872 26.3644C33.0033 28.1643 33.4328 31.1841 35.6492 32.4128C42.8161 36.3859 50.935 32.5823 52.6469 24.0116L46.5221 17.8867Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2539 38.8789H12.9198C10.9819 38.8789 9.41089 40.4499 9.41089 42.3878V52.722C9.41089 54.6598 10.9819 56.2308 12.9198 56.2308H23.2539C25.1918 56.2308 26.7628 54.6598 26.7628 52.722V42.3878C26.7628 40.4499 25.1918 38.8789 23.2539 38.8789Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8417 39.4297H35.0237C33.4744 39.4297 32.2185 40.6856 32.2185 42.2349C32.2185 43.7842 33.4744 45.0401 35.0237 45.0401H49.8418C51.3911 45.0401 52.647 43.7842 52.647 42.2349C52.647 40.6856 51.391 39.4297 49.8417 39.4297Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8417 50.0742H35.0237C33.4744 50.0742 32.2185 51.3301 32.2185 52.8794C32.2185 54.4287 33.4744 55.6846 35.0237 55.6846H49.8418C51.3911 55.6846 52.647 54.4287 52.647 52.8794C52.647 51.3303 51.391 50.0742 49.8417 50.0742Z",
    stroke: "#FF8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighFidelityDesign);
export default __webpack_public_path__ + "static/media/high-fidelity-design.abdfbb0042946eeed0089cf02cbc7a58.svg";
export { ForwardRef as ReactComponent };